<template>
    <div :class="'cu-panel tw-mb-2 ' + (released_at == null ? 'to_release' : 'released')">
        <div class="cu-panel-header">
            <div class="pull-left">
                <strong>
                    <i :class="released_at == null ? 'fa fa-exclamation-circle tw-text-red-500' : 'fa fa-check-circle tw-text-green-500'"></i>
                    {{ "KW " + initialUserReleases.calendar_week + "/" + initialUserReleases.year }}
                </strong>

                {{ " - " + (released_at == null ? translate('not_released_yet') : 
                    translate('released') + ' - ' + (lastAuthor == null ? '' : lastAuthor) + ' (' + moment(released_at).format('DD.MM.YYYY') + ')') }}
            </div>

            <div class="pull-right tw-space-x-5">
                <button v-if="didLoad && open && showDetail.includes(false)" class="cu-btn-xs" type="button" @click="allInfo()"><i class="fa fa-info-circle tw-mr-1"></i>{{ translate('for_all') }}</button>
                <button v-if="canEdit && released_at == null && (userReleases.length > 0 || !didLoad)" class="cu-btn-xs" type="button" @click="all()">
                    {{ translate('release_all') }}
                </button>
                <i :class="'fa heading-icon collapse-trigger tw-cursor-pointer fa-angle-double-' + (initialUserReleases.releases != null ? 'up' : 'down')" @click="load()"></i>
            </div>

            <div class="clearfix"></div>
        </div>

        <div ref="body" class="cu-panel-body" :style="'display:' + (initialUserReleases.releases != null ? 'block;' : 'none;')">
            <div v-if="error != null" class="tw-bg-warning-primary">{{ error }}</div>

            <div class="tw-flex tw-p-4 tw-text-xl tw-items-center tw-justify-center"
                 v-if="! didLoad && loading"
            >
                <i class="fa fa-spinner fa-pulse"></i>
            </div>

            <div v-if="didLoad && userReleases.length == 0 && error == null" class="tw-bg-warning-secondary">{{ translate('empty_department') }}</div>
            <div v-if="didLoad && userReleases.length > 0">
                <table class="cu-table">
                    <tr>
                        <th>{{ translate('label_employee') }}</th>
                        <th>{{ translate('worked') }}</th>
                        <th>{{ translate('absent') }}</th>
                        <th>{{ translate('possible_hours_by_contract') }}</th>
                        <th>{{ translate('overtime') }}</th>
                        <th>{{ translate('released') }}</th>
                        <th class="tw-text-right">{{ translate('actions') }}</th>
                    </tr>
                    <template v-for="(release, index) in userReleases" v-if="userReleases.length > 0">
                        <tr :class="release.released_at == null ? 'tw-bg-warning-secondary' : 'tw-bg-success-secondary'"
                            :style="showDetail[index] ? 'border-bottom-style:dotted;' : ''"
                        >
                            <td>
                                <a class="cu-link" :href="'/workday-record/history/monthly/' + release.user_id + '/' + initialUserReleases.year + '/' + initialUserReleases.month">
                                    {{ release.lastname + ', ' + release.firstname }}
                                </a>
                            </td>
                            <td>{{ renderTimespan(release.worked * 60) }}</td>
                            <td>{{ renderTimespan(release.absences * 60) }}</td>
                            <td>{{ renderTimespan(release.hours * 60) }}</td>
                            <td>{{ renderTimespan(release.overtime * 60) }}</td>
                            <td>
                                {{ release.released_by_user ? release.released_by_user : translate('not_released_yet') }}
                                <br>
                                {{ release.released_at ? moment(release.released_at).format('DD.MM.YYYY') : "" }}
                            </td>
                            <td class="tw-text-right" style="white-space: nowrap;">
                                <button 
                                    v-if="(canEdit && released_at == null) || canUndo" 
                                    class="cu-btn-default-sm" 
                                    type="button" 
                                    @click="toggleRelease(index)"
                                    :title="release.released_at == null ? translate('hours_release') : translate('undo_release')"
                                >
                                    <i :class="release.released_at == null ? 'fa fa-check' : 'fa fa-times'"></i>
                                </button>
                                <button 
                                    :class="'cu-btn-' + (showDetail[index] ? '' : 'default-') + 'sm'" 
                                    type="button" @click="toggleDetail(index)" 
                                    :title="translate('info')"
                                >
                                    <i class="fa fa-info-circle"></i>
                                </button>
                            </td>
                        </tr>
                        <tr style="border-top:none" v-if="showDetail[index]" :class="release.released_at == null ? 'tw-bg-warning-secondary' : 'tw-bg-success-secondary'">
                            <td>
                                <a target="_blank" class="cu-btn-default-sm" :href="'/worktimes/' + release.user_id + '/week/' + initialUserReleases.year + '/' + initialUserReleases.calendar_week">{{ translate('detail_view') }}</a>
                            </td>
                            <td><strong>{{ translate('sum') }}:</strong></td>
                            <td colspan="1">{{ renderTimespan(release.sum) }}</td>
                            <td><strong>{{ translate('cost_carriers') }}:</strong></td>
                            <td colspan="2">
                                <div v-if="! release.cost_carriers || release.cost_carriers.length == 0">
                                    {{ translate('no_cost_carriers') }}
                                </div>

                                <table class="tw-w-full">
                                    <tr v-for="(carrier, name, index) in release.cost_carriers">
                                        <td width="80%">
                                            <a :href="'/cost-carrier/' + carrier.id + '/user/' + release.user_id + '/worktimes/weekly/' + initialUserReleases.calendar_week + '/' + initialUserReleases.year">
                                                {{ name }}
                                            </a>
                                        </td>
                                        <td width="10%" class="tw-align-top tw-text-left tw-font-bold">
                                            <div class="tw-flex tw-w-full tw-justify-end tw-items-center tw-whitespace-nowrap tw-font-bold">
                                                <span class="tw-w-1/2 tw-flex tw-justify-end tw-items-center">
                                                    {{ Math.floor(carrier.sum / 60) == 0 ? '' : Math.floor(carrier.sum / 60) + 'h' }}
                                                </span>
                                                <span class="tw-w-1/2 tw-flex tw-justify-end tw-items-center tw-ml-1">
                                                    {{ (carrier.sum % 60) == 0 ? '' : Math.round(carrier.sum % 60) + 'm' }}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <td></td>
                        </tr>
                    </template>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import BorderedInput from "./BorderedInput";
    import moment from "moment";
    import axios from "axios";

    export default {
        components: {
            BorderedInput,
        },

        props: {
            initialUserReleases: {
                required: true,
                type: Object,
            },

            lang: {
                required: false,
                default() { return {} },
                type: Object,
            },

            canEdit: {
                required: true,
                type: Boolean,
            },

            canUndo: {
                default: false,
                type: Boolean,
            },

            openDetail: {
                default: false,
                type: Boolean,
            }
        },

        data() {
            return {
                userReleases: [],
                backupUserReleases: [],
                released_at: null,
                weeklyIdNumber: -1,
                showDetail: [],
                didLoad: false,
                open: false,
                loading: false,
                error: null,
                summaryText: "",
                lastAuthor: "",
                moment: moment,
                openDetailWhenLoading: false,
            }
        },

        methods: {
            renderTimespan(timespanInMinutes) {
                if (isNaN(timespanInMinutes)) {
                    return '-';
                }

                let result = '';
                if (timespanInMinutes < 0) {
                    timespanInMinutes = -timespanInMinutes;
                    result += '-';
                }
                if (timespanInMinutes >= 60) {
                    result += `${Math.floor(timespanInMinutes / 60)}h `;
                }
                if (timespanInMinutes % 60 != 0) {
                    result += `${Math.round(timespanInMinutes % 60)}m`
                }
                if (timespanInMinutes == 0) {
                    result = '0h'
                }
                return result;
            },

            toggleRelease(index) {
                if (this.userReleases[index].released_at == null) {
                    this.userReleases[index].released_at = moment().format('YYYY-MM-DD');
                    this.userReleases[index].released_by_user = null;
                } else {
                    this.userReleases[index].released_at = null;
                    this.userReleases[index].released_by_user = null;
                    this.userReleases[index].released_by_user_id = null;
                }
                this.save()
            },

            toggleDetail(index) {
                this.$set(this.showDetail, index, !(this.showDetail[index]));
            },

            reset() {
                this.userReleases = [];
                if (this.backupUserReleases.length > 0) {
                    this.backupUserReleases.forEach(item => {
                        let newItem = Object.assign({}, item);
                        newItem.released_at = item.released_at;
                        this.userReleases.push(newItem);
                        if (this.showDetail.length < this.backupUserReleases.length) {
                            this.showDetail.push(false);
                        }
                    })
                }

                if (this.openDetailWhenLoading) {
                    this.allInfo();
                } 
            },

            load(toggleOpen=true, callback=null) {
                if (toggleOpen) {
                    this.open = !this.open;
                }

                if (this.didLoad) {
                    return;
                }

                this.loading = true;

                let capturedThis = this;

                axios
                    .post("/worktime/releases/update/" + this.weeklyIdNumber, {
                        "releases": null
                    })
                    .then(function (response) {
                        capturedThis.openDetailWhenLoading = response.data.open_detail;
                        capturedThis.backupUserReleases = response.data.releases;
                        capturedThis.released_at = response.data.released_at;
                        capturedThis.reset();
                        capturedThis.lastAuthor = response.data.releaser;
                        capturedThis.didLoad = true;
                        if (callback != null) {
                            callback();
                        }
                    })
                    .catch(function (error) {
                        capturedThis.error = "Fehler mit der Netzwerkverbindung."
                    })
                    .then(() => {
                        this.loading = false;
                    })
                ;
                
            },

            save() {
                var capturedThis = this;

                axios.post("/worktime/releases/update/" + this.weeklyIdNumber, {
                    "releases": this.userReleases
                })
                    .then(function (response) {
                        capturedThis.backupUserReleases = response.data.releases;
                        capturedThis.released_at = response.data.released_at;
                        capturedThis.reset();
                        capturedThis.lastAuthor = response.data.releaser;
                    })
                    .catch(function (error) {
                        capturedThis.error = "Fehler mit der Netzwerkverbindung."
                    });
            },

            all() {
                var capturedThis = this;
                    
                var toggleAll = function () {
                    capturedThis.userReleases.forEach(function (release, index) {
                        if (release.released_at == null) {
                            capturedThis.toggleRelease(index);
                        }
                    })
                    capturedThis.save();
                }

                if (!(this.didLoad)) {
                    this.load(false, toggleAll);
                } else {
                    toggleAll();
                }
            },
            
            allInfo() {
                for (var i = 0; i < this.showDetail.length; i++) {
                    this.$set(this.showDetail, i, true);
                }
            },

            translate(text) {
                if (this.lang[text] != undefined) {
                    return this.lang[text];
                } else {
                    return text;
                }
            }
        },

        mounted() {
            this.openDetailWhenLoading = this.openDetail;
            this.weeklyIdNumber = this.initialUserReleases.weekly_id;
            this.lastAuthor = this.initialUserReleases.releaser;
            if (this.initialUserReleases.releases) {
                this.initialUserReleases.releases.forEach(item => {
                    let newItem = Object.assign({}, item);
                    newItem.released_at = item.released_at;
                    this.backupUserReleases.push(newItem);
                })
                this.didLoad = true;
                this.reset();
                this.open = true;
            }
            this.released_at = this.initialUserReleases.released_at;
        }
    }
</script>